/**
 * 何宽 2021.6.22
 * 根据对象数组的某个属性值对其进行排序
 */
const arrayFun = {
  // 根据某个属性值，对数组进行从大到小排序
  compareBtoS(key)
  {
    return function(obj1, obj2)
    {
      let val1 = obj1[key]
      let val2 = obj2[key]
      return -(val1 - val2)
    }
  },
  // 根据某个属性值，对数组进行从小到大排序
  compareStoB(key)
  {
    return function(obj1, obj2)
    {
      let val1 = obj1[key]
      let val2 = obj2[key]
      return (val1 - val2)
    }
  }
}
export default arrayFun



// WEBPACK FOOTER //
// ./src/plugins/app/method/array.js